var _defs, _path, _path2, _path3, _circle, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLockTool(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".lock-tool-cls-1{fill:#4f4f52;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard 14") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "lock-tool-cls-1",
    d: "M48.08,58.37a1,1,0,0,1-1-1v-.72a1,1,0,0,1,2,0v.72A1,1,0,0,1,48.08,58.37Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "lock-tool-cls-1",
    d: "M79.92,61.49a1,1,0,0,1-1-1V52.59c0-7.87-6.55-14-14.92-14s-14.92,6.17-14.92,14v7.89a1,1,0,0,1-2,0V52.59c0-9,7.43-16,16.92-16s16.92,7,16.92,16v7.89A1,1,0,0,1,79.92,61.49Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "lock-tool-cls-1",
    d: "M85.23,62.25A1.77,1.77,0,0,1,87,64V89.67a1.77,1.77,0,0,1-1.77,1.77H42.77A1.77,1.77,0,0,1,41,89.67V64a1.77,1.77,0,0,1,1.77-1.77H85.23m0-2H42.77A3.77,3.77,0,0,0,39,64V89.67a3.77,3.77,0,0,0,3.77,3.77H85.23A3.77,3.77,0,0,0,89,89.67V64a3.77,3.77,0,0,0-3.77-3.77Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "lock-tool-cls-1",
    cx: 64,
    cy: 82.6,
    r: 1.77
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "lock-tool-cls-1",
    x: 63.12,
    y: 83.48,
    width: 1.77,
    height: 3.54
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockTool);
export default __webpack_public_path__ + "static/media/lock_tool.65cf01c66f27fd594ef9ccc69d087ab5.svg";
export { ForwardRef as ReactComponent };